"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReturnsCSVFileName = getReturnsCSVFileName;
const date_fns_1 = require("date-fns");
const center_1 = require("../center");
function getReturnsCSVFileName(scanCenter) {
    switch (scanCenter) {
        case center_1.ActiveScanCenterCodeEnum.SRZ:
            return `${scanCenter}_Returns.csv`;
        case center_1.ActiveScanCenterCodeEnum.ODS:
        case center_1.ActiveScanCenterCodeEnum.SPS:
            return `${(0, date_fns_1.format)(new Date(), 'yyyyMMddHHmm')}_${scanCenter}_Returns.csv`;
        default:
            throw new Error(`Invalid scan center code ${scanCenter}`);
    }
}
//# sourceMappingURL=get-returns-csv-file-name.js.map